import React, {useContext, useEffect, useState} from 'react';
import {Button, message} from 'antd';
import ImportTableModal from '../common/ImportTableModal';
import EditComponent from '../common/EditComponent';
import DeleteComponent from '../common/DeleteComponent';
import {Arguments} from '../common/Arguments';
import {sideMenuContext} from '../../../router/IndexRouter';
import {GetApiMethod, PostToJava} from '../common/ApiMethod';
import SearchBox from '../common/SearchBoxComponent';
import {ExportToExcel} from '../common/ExportDataToExcelComponent';
import {SortByMemberUnitPost} from '../common/SortListByPost';
import BatchDelTableComponent from '../common/BatchDelComponent';

export default function MemberCompany(props) {
	const currentUrl = window.location.href;
	const {dataSource, setDataSource, setCopyDataSource} = useContext(sideMenuContext);
	const getApi = Arguments.host + '/society_organization/society/api!memberCompany.do';
	const [selectedRowKeys, setSelectedRowKeys] = useState([]);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		// 由于dataSource 是全局变量，导致新的页面会携带上一个页面的值，因此需要重新置空
		setDataSource([]);
		GetApiMethod({getApi, setDataSource, setCopyDataSource});
	}, [getApi]);

	const onSelectChange = (newSelectedRowKeys) => {
		setSelectedRowKeys(newSelectedRowKeys);
	};

	const rowSelection = {
		selectedRowKeys,
		onChange: onSelectChange,
	};

	const hasSelected = selectedRowKeys.length > 0;

	const resetSelect = () => {
		setSelectedRowKeys([]);
	};

	const deleteSelected = () => {
		setLoading(true);
		const ids = selectedRowKeys.map(key => dataSource[key - 1].memberUnitId);
		const batchDelApi = Arguments.host + '/society_organization/batchDelete/api!delMemberUnit.do';
		const postData = {
			delIds: ids.join('&&'),
		};
		PostToJava(batchDelApi, postData).then(res => {
			if (res?.data.code === 1) {
				message.success('批量删除成功');
			} else {
				message.error('删除失败');
			}
			setLoading(false);
			setSelectedRowKeys([]);
		}).then(() => GetApiMethod({getApi, setDataSource, setCopyDataSource}));
	};

	const columns = [
		{
			title: '序号',
			dataIndex: 'key',
			width: 100,
			sorter: (a, b) => a.key - b.key,
			sortDirections: ['ascend', 'descend'],
		},
		{
			title: '单位名称',
			dataIndex: 'memberUnitName',
			width: 200,
		},
		{
			title: '单位性质',
			responsive: ['lg'],
			dataIndex: 'memberUnitAttribute',
			width: 120,
		},
		{
			title: '法定代表人',
			dataIndex: 'memberUnitCorporation',
			width: 120,
		},
		{
			title: '单位地址',
			responsive: ['lg'],
			dataIndex: 'memberUnitAddress',
			width: 300,
		},
		{
			title: '联系人',
			dataIndex: 'memberUnitMeetingPeople',
			width: 120,
		},
		{
			title: '联系电话',
			dataIndex: 'memberUnitMeetingPeoplePhone',
			width: 140,
		},
		{
			title: '操作',
			width: 140,
			render: (item) => (
				<>
					<EditComponent item={item} url={currentUrl}/>
					<DeleteComponent
						item={item}
						postApi={[Arguments.host + '/society_organization/society/api!addMemberCompany.do']}
						getApi={getApi}
					/>
				</>
			),
		},
	];

	const newData = dataSource?.map(
		(
			{
				memberUnitName,
				memberUnitAttribute,
				memberUnitCorporation,
				memberUnitAddress,
				memberUnitMeetingPeople,
				memberUnitMeetingPeoplePhone,
			},
		) => (
			{
				'单位名称': memberUnitName,
				'单位性质': memberUnitAttribute,
				'法定代表人': memberUnitCorporation,
				'单位地址': memberUnitAddress,
				'联系人': memberUnitMeetingPeople,
				'联系电话': memberUnitMeetingPeoplePhone,
			}
		),
	);

	const indexDataSource = SortByMemberUnitPost(dataSource).map((data, index) => ({key: index + 1, ...data}));

	const tableTitle = [
		'member_unit_name',
		'member_unit_attribute',
		'member_unit_corporation',
		'member_unit_address',
		'member_unit_meeting_people',
		'member_unit_meeting_people_phone',
	];

	return (
		<>
			<Button type="primary" onClick={() => props.history.push('/society/member-company/add')}
					style={{marginBottom: 10}}>新增</Button>
			<ImportTableModal
				titleText="单位会员信息导入"
				templateUrl={Arguments.reactUrl.replace('/#', '') + '/att/words/会员信息（单位）导入模板.xlsx'}
				uploadUrl={Arguments.host + '/society_organization/batchImport/api!memberUnit.do'}
				incrementId={'organization_member_unit_info.member_unit_id'}
				getApi={getApi}
				tableTitle={tableTitle}
				duplicateApi={Arguments.host + '/society_organization/society/api!duplicateMemberCompany.do'}
			/>
			<ExportToExcel tableData={newData}/>
			<SearchBox/>
			<Button type="primary" onClick={() => resetSelect()} disabled={!hasSelected} style={{marginLeft: 20}}>
				取消选择
			</Button>
			<Button type="primary" danger onClick={() => deleteSelected()} disabled={!hasSelected} loading={loading}
					style={{marginLeft: 10}}>
				全部删除
			</Button>
			<BatchDelTableComponent
				rowSelection={rowSelection}
				dataSource={indexDataSource}
				columns={columns}
				rowKey={(item) => item.key}
			/>
		</>
	);
}

